import { create } from 'zustand';
import { MedicalRecord } from '../types';

interface MedicalRecordStore {
  medicalRecords: MedicalRecord[];
  editingRecord: MedicalRecord | null;
  
  // Actions
  setMedicalRecords: (records: MedicalRecord[]) => void;
  addMedicalRecord: (record: MedicalRecord) => void;
  updateMedicalRecord: (record: MedicalRecord) => void;
  deleteMedicalRecord: (recordId: string) => void;
  setEditingRecord: (record: MedicalRecord | null) => void;
  
  // Computed
  getRecordsByPatient: (patientId: string) => MedicalRecord[];
  getRecentRecords: (limit?: number) => MedicalRecord[];
}

export const useMedicalRecordStore = create<MedicalRecordStore>((set, get) => ({
  medicalRecords: [],
  editingRecord: null,
  
  setMedicalRecords: (records) => set({ medicalRecords: records }),
  
  addMedicalRecord: (record) => set((state) => ({
    medicalRecords: [...state.medicalRecords, record]
  })),
  
  updateMedicalRecord: (record) => set((state) => ({
    medicalRecords: state.medicalRecords.map(r => r.id === record.id ? record : r)
  })),
  
  deleteMedicalRecord: (recordId) => set((state) => ({
    medicalRecords: state.medicalRecords.filter(r => r.id !== recordId)
  })),
  
  setEditingRecord: (record) => set({ editingRecord: record }),
  
  getRecordsByPatient: (patientId) => {
    const { medicalRecords } = get();
    return medicalRecords.filter(record => record.patientId === patientId);
  },
  
  getRecentRecords: (limit = 5) => {
    const { medicalRecords } = get();
    return medicalRecords
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      .slice(0, limit);
  }
}));